import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'pinCode',
    validate: Yup.number()
      .typeError('Mật khẩu phải là số')
      .test(
        'len',
        'Mật khẩu phải đủ 6 kí tự',
        (val) => val?.toString().length === 6,
      ),
  },
];
